module.exports = __webpack_public_path__ + "img/1718763422735-IMG_20240619_101357.jpg.7790d3ce.webp";